import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getContactContent,
  updateContactContent,
} from "../../actions/contactActions";
import { CONTACT_CONTENT_UPDATE_RESET } from "../../constants/contactConstants";

const AdminContactFormScreen = () => {
  const dispatch = useDispatch();

  const contactContentDetails = useSelector(
    (state) => state.contactContentDetails,
  );
  const { loading, error, content } = contactContentDetails;

  const contactContentUpdate = useSelector(
    (state) => state.contactContentUpdate,
  );
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = contactContentUpdate;

  const [title, setTitle] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [addressTitle, setAddressTitle] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [contactInfoLabel, setContactInfoLabel] = useState("");
  const [phone, setPhone] = useState("");
  const [showroomText, setShowroomText] = useState("");
  const [socialText, setSocialText] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    dispatch(getContactContent());
  }, [dispatch]);

  useEffect(() => {
    if (content?._id || content?.title) {
      setTitle(content.title || "");
      setFormTitle(content.formTitle || "");
      setAddressTitle(content.addressTitle || "");
      setBuildingName(content.buildingName || "");
      setStreet(content.street || "");
      setCity(content.city || "");
      setPostcode(content.postcode || "");
      setContactInfoLabel(content.contactInfoLabel || "");
      setPhone(content.phone || "");
      setShowroomText(content.showroomText || "");
      setSocialText(content.socialText || "");
      setInstagramUrl(content.instagramUrl || "");
      setImage(content.image || "");
    }
  }, [content]);

  useEffect(() => {
    if (successUpdate) {
      const timer = setTimeout(() => {
        dispatch({ type: CONTACT_CONTENT_UPDATE_RESET });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [dispatch, successUpdate]);

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      updateContactContent({
        title,
        formTitle,
        addressTitle,
        buildingName,
        street,
        city,
        postcode,
        contactInfoLabel,
        phone,
        showroomText,
        socialText,
        instagramUrl,
        image,
      }),
    );
  };

  return (
    <div className="container py-4" style={{ maxWidth: "1000px" }}>
      <h2 className="mb-4">Edit Contact Page</h2>

      {loadingUpdate && <p>Saving...</p>}
      {errorUpdate && <p className="text-danger">{errorUpdate}</p>}
      {successUpdate && <p className="text-success">Updated successfully</p>}

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : (
        <form onSubmit={submitHandler}>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Page Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Form Title</label>
              <input
                type="text"
                className="form-control"
                value={formTitle}
                onChange={(e) => setFormTitle(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Address Title</label>
              <input
                type="text"
                className="form-control"
                value={addressTitle}
                onChange={(e) => setAddressTitle(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Building Name</label>
              <input
                type="text"
                className="form-control"
                value={buildingName}
                onChange={(e) => setBuildingName(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Street</label>
              <input
                type="text"
                className="form-control"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">City</label>
              <input
                type="text"
                className="form-control"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Postcode</label>
              <input
                type="text"
                className="form-control"
                value={postcode}
                onChange={(e) => setPostcode(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Contact Info Label</label>
              <input
                type="text"
                className="form-control"
                value={contactInfoLabel}
                onChange={(e) => setContactInfoLabel(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input
                type="text"
                className="form-control"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Image URL</label>
              <input
                type="text"
                className="form-control"
                value={image}
                onChange={(e) => setImage(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Instagram URL</label>
              <input
                type="text"
                className="form-control"
                value={instagramUrl}
                onChange={(e) => setInstagramUrl(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Social Text</label>
              <input
                type="text"
                className="form-control"
                value={socialText}
                onChange={(e) => setSocialText(e.target.value)}
              />
            </div>

            <div className="col-12">
              <label className="form-label">Showroom Text</label>
              <textarea
                rows="3"
                className="form-control"
                value={showroomText}
                onChange={(e) => setShowroomText(e.target.value)}
              />
            </div>

            <div className="col-12">
              <button type="submit" className="btn btn-dark">
                Save Changes
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default AdminContactFormScreen;
